import { createStore } from "vuex";
import connectedUserStore from "./modules/connectedUser.store";
import dataSimulateurStore from "./modules/dataSimulateur.store";

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    connectedUserStore,
    dataSimulateurStore,
  },
});
